import React, { useEffect, useState } from 'react';
import SmokeForm from './SmokeForm';
import { getConsumptionOptions } from '../api';

function Consumption({ user, onBack, onSaved }) {
  const [style, setStyle] = useState('');
  const [styles, setStyles] = useState([]);

  useEffect(() => {
    getConsumptionOptions()
      .then((data) => setStyles(data.styles || []))
      .catch(() => {});
  }, []);

  if (style) {
    return (
      <SmokeForm
        user={user}
        consumptionStyle={style}
        onSaved={onSaved}
        onBack={() => setStyle('')}
      />
    );
  }

  return (
    <div className="container">
      <p className="brand">My Weed Buddy</p>
      <h1>Consumption</h1>
      <p className="subtitle">Choose how you consumed.</p>
      <div className="form-group">
        <label htmlFor="consumptionStyle">Consumption style</label>
        <select
          id="consumptionStyle"
          value={style}
          onChange={(e) => setStyle(e.target.value)}
        >
          <option value="">Select</option>
          {styles.map((option) => (
            <option key={option} value={option}>
              {option}
            </option>
          ))}
        </select>
      </div>
      <button type="button" className="secondary" onClick={onBack}>
        Back to welcome
      </button>
    </div>
  );
}

export default Consumption;
